import {
  isNumericFacet,
  getMainStoreInstance,
  getTotalRefinements,
  getCurrencySymbol,
  getMainHelper,
  mainStoreName,
  widgets,
} from '../../common/Algolia';

const facets = [
  'product_types',
  'concerns',
  'olfactive_notes',
  'textures',
  'collections',
  'price_f',
];

const nFacets = [];

const dicoClearKey = 'clear_all';
// Constants (ids)
const currentRefinedValuesId = 'ais-current-refined-values';
// Constants (class)
const tagBtnClass = 'm-tag-filter';
const tagItemClass = 'm-internal-search-filter-container__tag-item';
const clearAllClass = 'o-top-internal-search__clear';

/* Get store instance */
let occStore;

let dicoKeys;
let dicoClear;

/* DOM elements use as starting points */
let $clearAllRefined;

/* DOM elements use as starting points */
let $currentRefinedValues;

/* Register events once after the rendering complete */
function currentRefinedEventSetup() {
  if (typeof occStore !== 'undefined') {
    occStore.once('render', () => {
      $clearAllRefined = $('.ais-current-refined-values--clear-all');

      getMainHelper().on('result', () => {
        $clearAllRefined.toggle(getTotalRefinements() > 1);
      });
    });
  }
}

/* Searchbox wideget setup */
function currentRefinedValuesInit() {
  /* Init elements */
  $currentRefinedValues = $(`#${currentRefinedValuesId}`);

  if ($currentRefinedValues.length > 0) {
    const tempAttr = [];

    /* Get Store instance */
    occStore = getMainStoreInstance();

    try {
      dicoKeys = OCMS.aisPanel.dicoKeys;
      dicoClear = OCMS.aisPanel.dicoKeys[dicoClearKey];
    } catch (error) {
      console.error('===== Missing dicoKeys for AIS-CURRENT-REFINED-VALUES =====', error);
    }

    /* Loop through facets and associate dicokeys for labels */
    for (let i = 0, len = facets.length; i < len; i += 1) {
      tempAttr.push({ name: facets[i], label: dicoKeys[facets[i]] });

      if (isNumericFacet(facets[i])) {
        nFacets.push(facets[i]);
      }
    }

    occStore.addWidget(
      widgets.currentRefinedValues({
        attributes: tempAttr,
        container: $currentRefinedValues[0], // Expect a vanilla DOM object
        onlyListedAttributes: true,
        clearAll: 'after',
        templates: {
          item: (data) => { // TAG-LOOP
            const op = data.operator;
            const facet = data.attributeName;
            const isNum = (nFacets.indexOf(facet) !== -1);
            let tagContainerId = `tag-container--${facet}`;
            let tagId = `tag-label--${facet}`;
            let tagContent = null;

            if (isNum && typeof op !== 'undefined') {
              const idSuffix = `_${data.displayOperator.replace(/[&#;]*/g, '')}`;

              /* Refine unique id on numeric tag elements */
              tagId += idSuffix;
              tagContainerId += idSuffix;

              tagContent = `<span id="${tagId}" class="a-text-m ${tagBtnClass}__item">${data.computedLabel}
                            <span>${getCurrencySymbol(mainStoreName)}</span>
                            </span>`;
            } else {
              tagContent = `<span id="${tagId}" class="a-text-m ${tagBtnClass}__item">${data.computedLabel}</span>`;
            }

            return `<button id="${tagContainerId}" data-filterid="" type="button" class="o-top-internal-search__tag ${tagBtnClass}">
                      ${tagContent}
                      <i class="${tagBtnClass}__icon a-icon-css a-icon-css--cross-close"></i>
                    </button>`;
          },
          clearAll: `<button class="a-text-m a-text-m--link m-internal-search-filter-container__link" type="button">${dicoClear}</button>`,
        },
        cssClasses: {
          root: 'o-internal-search-filters__block o-internal-search-filters__block--bottom',
          body: 'o-top-internal-search__tag-container',
          clearAll: `${clearAllClass}`,
          list: 'm-internal-search-filter-container__list',
          item: `${tagItemClass}`,
        },
      })
    );

    /* Setup widget events after once the "render" competion */
    currentRefinedEventSetup();

    return true;
  }

  return false;
}

function getClearAllJQ() {
  return $(`.${clearAllClass}`);
}

// Named exports
export {
  currentRefinedValuesInit,
  getClearAllJQ,
};



// WEBPACK FOOTER //
// ./js/desktop/molecule/algolia-current-refined-values.js